import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Dropdown, Button, Title } from '@cambridgeassessment/cambridge-ui';
import { RootState } from '../../store';
import * as actions from '../../store/userData/actions';
import {
  StyledHeadline,
  StyledHeader,
  StyledBody,
  SeriesSelectContainer,
  StyledDropdownContainer,
} from './UserDataSelect.styles';
import { BusinessCentres } from '@cambridgeassessment/lib-ee-commons';

export const UserDataSelect: React.FC = () => {
  const dispatch = useDispatch();

  const [selectedBU, setSelectedBU] = useState<BusinessCentres | null>(null);
  const { availableBusinessUnits } = useSelector((state: RootState) => state.userData);

  const renderBUs = (item: BusinessCentres): string => item.fullName;

  const onBUSelected = (item: BusinessCentres): void => {
    setSelectedBU(item);
  };

  const onProceed = (): void => {
    if (!selectedBU) return;
    dispatch(actions.setBusinessUnit(selectedBU));
  };

  return (
    <SeriesSelectContainer data-qa-id='BU-select-page'>
      <StyledHeadline>Welcome</StyledHeadline>
      <StyledBody>Before you begin, please select the awarding body you want to manage</StyledBody>
      <StyledDropdownContainer>
        <StyledHeader>Awarding body</StyledHeader>
        {availableBusinessUnits?.length ? (
          <Dropdown<BusinessCentres>
            data={availableBusinessUnits}
            renderOption={renderBUs}
            renderSelectedOption={renderBUs}
            dataQaId='BU-select'
            onChange={onBUSelected}
            value={selectedBU}
            placeholder='Choose an awarding body'
            title='BusinessUnits'
          />
        ) : (
          <Title>There are no associated awarding bodies</Title>
        )}
        <Button qaId='BU-select-proceed' onClick={onProceed} disabled={!selectedBU}>
          Continue
        </Button>
      </StyledDropdownContainer>
    </SeriesSelectContainer>
  );
};

export default UserDataSelect;
